/**
 * Registers the `siteAdmin` namespace with the shared i18next instance. This is
 * the **shared** namespace for the whole Site-Admin console (slice 16 shell +
 * home); slices 17–21 extend the same bundle. Imported for its side effect by the
 * console shell so the namespace is available before any Site-Admin screen renders
 * (WEB PRD recipe: "module-owned namespaces register themselves via
 * `i18n.addResourceBundle`").
 *
 * **en-US only** — the console is DecisionPoint-internal, not customer-facing, so
 * it is not localized (docs/design/fe-build-goals/README.md "Site Admin is en-US
 * only"). Registering the bundle under en-US alone means every `siteAdmin` key
 * resolves to en-US via `fallbackLng`, whatever the operator's active language —
 * no half-translated console. Only en-US exists; the locale-parity test exempts
 * this namespace.
 */
import { i18n } from '../../i18n/config';
import enSiteAdmin from '../../locales/en-US/siteAdmin.json';

const NAMESPACE = 'siteAdmin';

// `overwrite` is false so re-registration during HMR / repeated test imports is a no-op.
i18n.addResourceBundle('en-US', NAMESPACE, enSiteAdmin, true, false);

export const siteAdminNamespace = NAMESPACE;
